/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applied_BadgeInputs */

const en_applied_badge = /** @type {(inputs: Applied_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied`)
};

const de_applied_badge = /** @type {(inputs: Applied_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beworben`)
};

/**
* | output |
* | --- |
* | "Applied" |
*
* @param {Applied_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applied_badge = /** @type {((inputs?: Applied_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applied_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applied_badge(inputs)
	return en_applied_badge(inputs)
});